export const hotkeys = {
  'mod+`': 'code',
  'mod+b': 'bold',
  'mod+i': 'italic',
  'mod+u': 'underline',
}
